import axiosInstance from "../../../utils/axiosInstance";
import { handleFrontendError } from "../../../utils/errorHandler";

export const OrderApis = {
  fetchOrders: async () => {
    try {
      const response = await axiosInstance.get(`/orders`);
      return response.data;
    } catch (error) {
      console.error(
        "Error updating order status:",
        error.response?.data || error.message
      );
      return { success: false, message: "Failed to update order status" };
    }
  },

  updateOrderStatus: async (data) => {
    try {
      const response = await axiosInstance.patch(
        `/orders/update/order-status`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error updating order status:",
        error.response?.data || error.message
      );
      return { success: false, message: "Failed to update order status" };
    }
  },

  updateOpenStatus: async () => {
    try {
      const response = await axiosInstance.post(
        `/profile/update/open-status`,
        {}
      );

      return response.data;
    } catch (error) {
      console.error(
        "Error updating order status:",
        error.response?.data || error.message
      );
      return handleFrontendError(error, "Failed to update open status");
    }
  },

  rejectOrder: async (orderNumber, reason) => {
    try {
      const response = await axiosInstance.post(`/orders/reject`, {
        orderNumber,
        reason,
      });

      return response.data;
    } catch (error) {
      console.error(
        "Error rejecting order:",
        error.response?.data || error.message
      );
      return handleFrontendError(error, "Failed to reject order");
    }
  },
};
